module.exports = __webpack_public_path__ + "static/media/image-11.8e5986ea.png";